import { getPrivateApi } from "../lib/axiosConfig";
import { Feedback } from "../types/feedback.types";
import { AppError } from "./classes";

const api = getPrivateApi();
const endpoint = "/feedbacks";

/**
 * Endpoints do `FeedbackController` (core, branch `main`). Todos devolvem
 * `List<FeedbackResponseDTO>` puro — nenhum é paginado.
 */

export const getFeedbacks = async (): Promise<Feedback[]> => {
  try {
    const { data } = await api.get<Feedback[]>(endpoint);
    return data;
  } catch (error: any) {
    const errMsg = "Erro ao buscar feedbacks";
    console.error(errMsg, error?.response ?? error);
    const message = error?.response?.data?.message ?? errMsg;
    throw new AppError(message, error?.response?.status ?? 500);
  }
};

/**
 * Filtra pelo CODE do posto (ex.: "Z7"), não pelo id.
 *
 * Não usado pela tela: hoje devolve sempre lista vazia, porque `stationCode`
 * nunca é preenchido — o app não envia o campo e o `FeedbackServiceImpl` grava
 * `request.getStationCode()` direto, sem derivar do usuário autenticado.
 * Ligar o filtro de posto na tela depende de corrigir isso antes.
 */
export const getFeedbacksByStation = async (stationCode: string): Promise<Feedback[]> => {
  try {
    const { data } = await api.get<Feedback[]>(`${endpoint}/station/${stationCode}`);
    return data;
  } catch (error: any) {
    const errMsg = "Erro ao buscar feedbacks do posto";
    console.error(errMsg, error?.response ?? error);
    const message = error?.response?.data?.message ?? errMsg;
    throw new AppError(message, error?.response?.status ?? 500);
  }
};

/**
 * Match exato no campo `category`, que é uma string livre — na prática, o módulo
 * de origem gravado pelo app (`profile`, `payment`...).
 *
 * NÃO serve para filtrar Melhoria/Erro/Sugestão: isso é o campo `type`, que não
 * tem endpoint próprio e é filtrado no cliente.
 *
 * Não usado pela tela. Mantido porque o endpoint existe e é o caminho pronto
 * caso se queira, no futuro, um filtro por módulo de origem.
 */
export const getFeedbacksByCategory = async (category: string): Promise<Feedback[]> => {
  try {
    const { data } = await api.get<Feedback[]>(`${endpoint}/category/${category}`);
    return data;
  } catch (error: any) {
    const errMsg = "Erro ao buscar feedbacks da categoria";
    console.error(errMsg, error?.response ?? error);
    const message = error?.response?.data?.message ?? errMsg;
    throw new AppError(message, error?.response?.status ?? 500);
  }
};
